import { apiGet, apiPost, apiPut, apiDelete } from './api'
import type { Equipment, EquipmentCreate, EquipmentUpdate } from '../types'

export const equipmentApi = {
  getBySystem(systemId: string): Promise<Equipment[]> {
    return apiGet<Equipment[]>(`/equipment/system/${systemId}`)
  },

  getById(id: string): Promise<Equipment> {
    return apiGet<Equipment>(`/equipment/${id}`)
  },

  create(data: EquipmentCreate): Promise<Equipment> {
    return apiPost<Equipment>('/equipment', data)
  },

  update(id: string, data: EquipmentUpdate): Promise<Equipment> {
    return apiPut<Equipment>(`/equipment/${id}`, data)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/equipment/${id}`)
  },
}
